export default {
  ShowTransfer: 1,
  ShowCAReceipt: 2,
  Save: 2,
  SaveAdd: 3,
  SaveClose: 4,
  // Hoãn
  Postpone: 5,
  NextVoucher: 6,
  BackVoucher: 7,
  SaveView: 8,
  Ok: 9,
  Delete: 10,
  All: 11,
  Follow: 12,
  Unfollow: 13,
  Active: 14,
  Unactive: 15,
  Edit: 16,
  Duplicate: 17,
  Add: 18,
  Approve: 19,
  Reject: 20,
  View: 21,
  Posted: 22,
  UnPosted: 23,
  Estimate: 24,
  NextStep: 25,
  BackStep: 26,
  ViewAccount: 27,
  ViewQuantity: 28,
  AddAutoBusiness: 29,
  GenerateData: 30,
  GenerateCaPaymentSalary: 31,
  Refresh: 32,
  ChangeStatusPosted: 33,
  Copy: 34,
  ShowWithDrawCash: 35,
  ShowWithDrawDeposit: 36,
  ShowWithDrawTransfer: 37,
  ShowWithDrawSalaryTransfer: 38,
  ShowBUTreasuryFundTransferSalary: 39,
  ShowBUTreasuryFundTransferInsurancePayment: 40,
  GLVoucherDetail: 41,
  SaveParalell: 42,
  InsertRowGrid: 43,
  DeleteRowGrid: 44,
  PostponeParalell: 45,
  Cancel: 46,
  SettingAccount: 47,
  // Gửi phê duyệt
  SendApproval: 48,
  Quit: 49,

  // Bảng kê
  BUVoucherListPlanned: 50,
  BUVoucherListNotPlanned: 51,
  BUVoucherListReceipExpense: 52,
  BUVoucherListRealExpense: 53,
  BUVoucherListOther: 54,

  // Sinh các loại giấy rút
  GenerateBUPlanWithdrawTransferDetail: 55, // Giấy rút dự toán tiền mặt
  GenerateBUPlanWithdrawDepositDetail: 56, // Giấy rút dự toán tiền gửi
  GenerateCAReceiptWithdrawDetail: 57,
  // In chứng từ
  Print_C213_TT772017_ST: 58,

  // Hóa đơn
  CreateSaleVoucher: 59,
  ReleaseInvoice: 60,
  CancelInvoice: 61,
  SendInvoice: 62,
  SendNotify: 63,
  CreateSaleVoucherMulti: 64,
  CreateAdjustSaleInvoice: 65, // Lập hóa đơn điều chỉnh vqphong - 22.09.2022
  SaleInvoiceReplace: 66, // Lập hóa đơn thay thế
  DownloadInvoice: 67, // Tải hóa đơn
  ConvertToPaperVoucher: 68, // Chuyển thành hóa đơn giấy
  GenerateInvoice: 69, // Lập hóa đơn
  PublishInvoiceMulti: 70,
  PublishInvoice: 71,

  // Nhập số dư
  AccountBalance: 72,
  // Đóng thuế
  PayTax: 73,

  // Lương
  SalaryAllocation: 74,
  // sinh chi tiền gửi
  GenerateDrawSalary: 75,
  GenerateDataFundSalary: 76, // sinh hạch toán chi phí lương
  GenerateDataFundInsurance: 77, // sinh hạch toán chi phí bảo hiểm
  InvolveVoucher: 78, // Chứng từ liên quan
};
